let Vue = require('vue').default;
var axios = require('./common').axios;
let snotify = require('vue-snotify');
let snotifyMixin = require('./components/snotifyMixin.js').default;

Vue.use(snotify.default);

module.exports = function(context) {
    return new Vue({
        el: '#forgotPasswordForm',
        data: {
            email: '',
            validationState: {},
            wasValidated: false,
            emailSent: false,
        },
        mixins: [snotifyMixin],
        methods: {
            onSubmit: function () {
                var vm = this;
                axios.post('/Auth/ForgotPassword', {email: vm.email})
                    .then(function (response) {
                        if (response.status == 200) {
                            vm.emailSent = true;
                        }  
                    })
                    .catch(function (error) {
                        var body = error.response.data;
                        vm.wasValidated = true;
                        if (body.state)
                            vm.$set(vm, "validationState", body.state);
                        if (body.state.general)
                            vm.showError('Server Error', body.state.general);
                    });
            }
        }
    });
}